import React from "react";
import AllServicesGrid from "@/components/sections/AllServicesGrid";
import HowCanWeHelp from "@/components/sections/HowCanWeHelp";
import ContactSection from "@/components/sections/ContactSection";
import BigCTA from "@/components/sections/BigCTA";

export default function ServicesPage() {
  return (
    <main data-testid="services-page" className="pt-36 md:pt-44">
      <section className="container-x pb-10">
        <div className="max-w-3xl">
          <h1 className="text-[36px] md:text-[56px] font-extrabold text-navy leading-[1.1]">All services</h1>
          <p className="mt-4 text-ink/85 text-[18px] max-w-2xl">
            Home nursing, caretakers and health checkups — all delivered at your home across Bangalore. Tap any card to chat on WhatsApp.
          </p>
        </div>
      </section>
      <HowCanWeHelp />
      <AllServicesGrid />
      <BigCTA />
      <ContactSection />
    </main>
  );
}
